import { render, staticRenderFns } from "./setmeal.vue?vue&type=template&id=3b491450&scoped=true"
import script from "./setmeal.vue?vue&type=script&lang=js"
export * from "./setmeal.vue?vue&type=script&lang=js"
import style0 from "./setmeal.vue?vue&type=style&index=0&id=3b491450&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b491450",
  null
  
)

export default component.exports